/**
 * Stores the list of robot types from the list of available robots and their
 * associated class. This will need to be updated whenever new robots are added
 * to the repo!
 */
export const robotClass: {[robotType: string]: string} = {
  CERBERUS_ANYMAL_B: 'ANYMAL_B',
  CERBERUS_ANYMAL_C: 'ANYMAL_C',
  CERBERUS_M100: 'M100',
  CERBERUS_GAGARIN: 'GAGARIN',
  CERBERUS_RMF: 'RMF',
  COSTAR_HUSKY: 'HUSKY',
  COSTAR_SHAFTER: 'SHAFTER',
  CSIRO_DATA61_OZBOT_ATR: 'OZBOT_ATR',
  CSIRO_DATA61_DTR: 'DTR',
  CTU_CRAS_NORLAB_ABSOLEM: 'ABSOLEM',
  CTU_CRAS_NORLAB_HUSKY: 'HUSKY',
  CTU_CRAS_NORLAB_LILY: 'LILY',
  CTU_CRAS_NORLAB_MARMOTTE: 'HD2',
  CTU_CRAS_NORLAB_MARV: 'MARV',
  CTU_CRAS_NORLAB_SPOT: 'SPOT',
  CTU_CRAS_NORLAB_X500: 'X500',
  EMESENT_HOVERMAP: 'HOVERMAP',
  EXPLORER_DS1: 'DS1',
  EXPLORER_R2: 'R2',
  EXPLORER_R3: 'R3',
  EXPLORER_X1: 'X1',
  CORO_ALLIE: 'ALLIE',
  CORO_CRYSTAL: 'CRYSTAL',
  CORO_KAREN: 'KAREN',
  CORO_JEANINE: 'JEANINE',
  CORO_MIKE: 'MIKE',
  CORO_PAM: 'PAM',
  CORO_ROCKY: 'ROCKY',
  MARBLE_HD2: 'HD2',
  MARBLE_HUSKY: 'HUSKY',
  MARBLE_QAV500: 'QAV500',
  MARBLE_SPOT: 'SPOT',
  ROBOTIKA_FREYJA: 'FREYJA',
  ROBOTIKA_KLOUBAK: 'KLOUBAK',
  ROBOTIKA_X2: 'X2',
  SOPHISTICATED_ENGINEERING_X2: 'X2',
  SOPHISTICATED_ENGINEERING_X4: 'X4',
  SSCI_X2: 'X2',
  SSCI_X4: 'X4',
  TEAMBASE: 'TEAMBASE',
  X1: 'X1',
  X2: 'X2',
  X3: 'X3',
  X4: 'X4'
};
